module.exports = __webpack_public_path__ + "img/4.4f842558.gif";